<div class="w-full space-y-6 animate-fade-in">
  <!-- Welcome Text -->
  <div class="text-center md:text-left">
    <h2 class="text-2xl font-bold text-greyscale-900 mb-2">
      {{ "login.welcomeBack" | transloco }}
    </h2>
    <p class="text-paragraph-s-reg text-greyscale-600">
      {{ "login.subtitle" | transloco }}
    </p>
  </div>

  <!-- Form -->
  <form
    class="flex flex-col gap-4"
    [formGroup]="profilForm"
    (ngSubmit)="onLogin()"
  >
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-user" />
      <input
        class="w-full"
        type="text"
        name="email"
        data-testid="login-email-input"
        [attr.placeholder]="'login.email' | transloco"
        formControlName="email"
        pInputText
      />
    </p-iconField>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-lock" />
      <input
        class="w-full"
        [type]="isPasswordVisible ? 'text' : 'password'"
        name="password"
        data-testid="login-password-input"
        [attr.placeholder]="'login.password' | transloco"
        formControlName="password"
        pInputText
      />
      <p-inputIcon
        (click)="tooggleShowPassword()"
        [ngClass]="isPasswordVisible ? 'pi pi-eye-slash' : 'pi pi-eye'"
        class="hover:cursor-pointer"
      />
    </p-iconField>

    <p-toast />

    <button
      class="flex w-full items-center justify-center rounded-md border border-transparent bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      data-testid="login-button"
      [disabled]="loading"
      type="submit"
    >
      @if (loading) {
        <i class="pi pi-spin pi-spinner mr-2"></i>
      } @else {
        <i class="pi pi-sign-in mr-2"></i>
      }
      {{ "login.getStarted" | transloco }}
    </button>
  </form>

  <!-- Links -->
  <div class="flex flex-col items-center md:items-start gap-2">
    <a
      class="text-sm font-medium text-primary-600 no-underline hover:text-primary-500"
      routerLink="/auth/register"
    >
      {{ "login.createAccount" | transloco }}
    </a>
    <a
      class="text-sm text-greyscale-600 no-underline hover:text-greyscale-700"
      routerLink="/auth/forgot-password"
    >
      {{ "login.forgotPassword" | transloco }}
    </a>
  </div>
</div>
